import { useState, useEffect } from 'react'

const useWindowScrollYBetween = (start = 0, end = Number.POSITIVE_INFINITY) => {
    const [isBetween, setIsBetween] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > start && window.scrollY < end) {
                setIsBetween(true)
            } else {
                setIsBetween(false)
            }
        }

        window.addEventListener('scroll', handleScroll)

        // call init once
        handleScroll()

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [start, end])

    return isBetween
}

export default useWindowScrollYBetween
